import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="0 0 20 16"
  return (
    <>
      <path
        fill={color}
        d="M18.413 0H1.502C.673 0 0 .673 0 1.502v12.996C0 15.327.673 16 1.502 16h16.911c.829 0 1.502-.673 1.502-1.502V1.502C19.915.673 19.242 0 18.413 0Zm.608 14.498a.61.61 0 0 1-.608.608H1.502a.61.61 0 0 1-.608-.608V1.502a.61.61 0 0 1 .608-.608h16.911a.61.61 0 0 1 .608.608v12.996Z"
      />
      <path
        fill={color}
        d="M9.57 7.928a.448.448 0 0 0-.617.14l-2.199 3.487V2.899a.446.446 0 1 0-.893 0v8.67l-2.232-3.5a.447.447 0 0 0-.754.48l3.057 4.793a.448.448 0 0 0 .754-.003L9.71 8.545a.448.448 0 0 0-.14-.617ZM13.857 11.211c-.781 0-1.416-.553-1.416-1.232a.707.707 0 0 0-.708-.704.704.704 0 0 0-.709.704c0 1.228.903 2.259 2.12 2.55v.473c0 .386.316.704.709.704a.704.704 0 0 0 .708-.704v-.473c1.218-.291 2.12-1.322 2.12-2.55 0-1.455-1.27-2.636-2.828-2.636-.782 0-1.417-.554-1.417-1.232 0-.679.635-1.233 1.417-1.233.781 0 1.416.554 1.416 1.233 0 .386.315.704.708.704a.704.704 0 0 0 .709-.704c0-1.228-.903-2.259-2.12-2.55v-.473a.707.707 0 0 0-.709-.704.704.704 0 0 0-.708.704v.472c-1.218.292-2.12 1.323-2.12 2.55 0 1.456 1.27 2.637 2.828 2.637.782 0 1.417.554 1.417 1.232 0 .679-.635 1.232-1.417 1.232Z"
      />
    </>
  );
}
